import api from '../../services/api'

const state = {
  stats: {
    totalUtilisateurs: 0,
    utilisateursActifs: 0,
    utilisateursInactifs: 0,
    nouvellesInscriptions: 0
  },
  statistiquesParRole: [],
  activiteRecente: [],
  utilisateursParMois: [],
  loading: false
}

const mutations = {
  SET_DASHBOARD_DATA(state, data) {
    state.stats = data.statistiques
    state.statistiquesParRole = data.statistiquesParRole
    state.activiteRecente = data.activiteRecente
    state.utilisateursParMois = data.utilisateursParMois
  },
  SET_LOADING(state, loading) {
    state.loading = loading
  }
}

const actions = {
  async fetchDashboardData({ commit }) {
    commit('SET_LOADING', true)
    
    try {
      const response = await api.get('/admin/dashboard')
      
      commit('SET_DASHBOARD_DATA', response.data)
      
      return response.data
    } catch (error) {
      const message = error.response?.data?.message || 'Erreur lors de la récupération des données du dashboard'
      throw new Error(message)
    } finally {
      commit('SET_LOADING', false)
    }
  }
}

const getters = {
  stats: state => state.stats,
  statistiquesParRole: state => state.statistiquesParRole,
  activiteRecente: state => state.activiteRecente,
  utilisateursParMois: state => state.utilisateursParMois,
  loading: state => state.loading
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
